
function subscribe<T>(eventName: string, listener: (event: CustomEvent<T>) => void) {
    document.addEventListener(eventName, listener as EventListener);
}

function unsubscribe<T>(eventName: string, listener: (event: CustomEvent<T>) => void) {
    document.removeEventListener(eventName, listener as EventListener);
}

function publish(eventName: string, data: any) {
    if (typeof window === "undefined") return;
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}

export { publish, subscribe, unsubscribe };
